export enum EGender {
    NONE,
    MALE,
    FEMALE
}